import { useEffect, useState, useRef } from 'react';

export default function PricingFAQ() {
  const [animated, setAnimated] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const faqs = [
    {
      question: 'Can I upgrade from Pre-Launch to Founder?',
      answer: 'No. Founder tier requires annual commitment. Pre-Launch is month-to-month',
    },
    {
      question: 'What happens when founder spots sell out?',
      answer: 'Founder tier closes permanently. New users pay Pre-Launch or Standard rates',
    },
    {
      question: 'Will my founder rate ever increase?',
      answer: 'No. Your $25/month rate is locked for the life of your account',
    },
    {
      question: 'What if I cancel and rejoin later?',
      answer: 'You lose founder pricing. Reactivation is at current rates',
    },
    {
      question: 'When does Pre-Launch pricing end?',
      answer: 'At public launch. Date TBD. Waitlist gets 48-hour notice',
    },
    {
      question: 'Is there a free trial?',
      answer: 'No trial. But 14-day refund, no questions asked',
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-[#09090b]">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className={`text-white text-[28px] sm:text-[36px] lg:text-[48px] font-black text-center mb-8 sm:mb-12 lg:mb-16 transition-all duration-700 ${
            animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          FAQ
        </h2>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-[#0f0f11] border border-[#1a1a1c] rounded-xl overflow-hidden transition-all duration-700 hover:border-[#06b6d4] ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4 text-left cursor-pointer"
              >
                <span className="text-white text-sm sm:text-base lg:text-lg font-bold">{faq.question}</span>
                <span className={`text-[#06b6d4] text-xl sm:text-2xl transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-45' : ''}`}>
                  +
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 sm:px-6 pb-4 sm:pb-5 text-[#d4d4d8] text-sm sm:text-base leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
